<template lang="pug">

.progress-bar

  .bar
    .progress(
      v-bind:style="{ \
        transform: transform, \
        transition: transition, \
        background: background \
      }"
    )

  .label
    animated-number(
      v-bind:number="progressLabel"
      v-bind:time="time"
    )
    span %



</template>

<script>
// import rightpad from 'right-pad'
import AnimatedNumber from 'src/components/animated-number/AnimatedNumber'

export default {
  name: 'progress-bar',
  components: {
    AnimatedNumber
  },
  props: [
    'progress',
    'time'
  ],
  data: ()=> {
    return {
      transform: 'translateX(-100%)',
      background: 'background: linear-gradient(to left, #1A3FED 0%, #EC201E 100%)',
      progressLabel: 0
    }
  },
  computed: {
    transition () {
      const time = this.time || 100
      const t = `all ${time}ms linear 0s`
      return t
    }
  },
  mounted: function() {

    this.enabled = true

    this.update = ()=> {

      if (!this.enabled) return

      // TRANSFORM
      let translate = 0
      if (this.progress >= 1) {
        translate = 0
      } else {
        translate = 100 - this.progress * 100
      }
      translate = Math.round(translate * 2.4) / 2.4
      this.transform = `translateX(-${translate}%)`

      // BACKGROUND
      this.background = `linear-gradient(to left, #EC201E 0%, #1A3FED ${this.progress * 100}%)`

      // LABEL
      this.progressLabel = Math.floor(this.progress * 100)

    }

    this.interval = setInterval(this.update, this.time)

  },
  beforeDestroy: function() {
    this.enabled = false
    clearInterval(this.interval)
  }

}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

.fade-enter-active, .fade-leave-active
  transition: all 0.4s ease 0s

.fade-enter, .fade-leave-active
  opacity: 0


.progress-bar

.bar
  position: relative
  box-sizing: content-box
  height: 10px
  width: 180px
  margin: 16px auto
  background-color: #242A63
  border-radius: 20px
  overflow: hidden
  -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC)

.progress
  position: relative
  top: 0
  left: 0
  width: 100%
  height: 100%
  border-radius: 20px
  transform-origin: 0 50%
  transform: translateX(-100%)
  transform: scaleX(0)
  transition: transform 0.1s linear 0s
  +flex-center()

.label
  color: white
  z-index: 1
  font-size: 1.6rem
  left: 0
  right: 0
  margin: 0 auto
  width: 100%
  text-align: center




</style>






// WEBPACK FOOTER //
// ProgressBar.vue?616fda49